.root {
  padding: 1rem 1rem;
}
